<script setup lang="ts">
import { PhCheck, PhCopySimple } from "@phosphor-icons/vue"
import { onBeforeUnmount, ref } from "vue"

const props = defineProps<{
  compact?: boolean
  label?: string
  value: string
}>()

const copied = ref(false)
let resetTimer: number | undefined

async function copyValue() {
  try {
    await navigator.clipboard?.writeText(props.value)
    copied.value = true
    if (resetTimer) {
      window.clearTimeout(resetTimer)
    }
    resetTimer = window.setTimeout(() => {
      copied.value = false
      resetTimer = undefined
    }, 1200)
  } catch {
    copied.value = false
  }
}

onBeforeUnmount(() => {
  if (resetTimer) {
    window.clearTimeout(resetTimer)
  }
})
</script>

<template>
  <UTooltip :text="copied ? 'Copied' : (label ?? 'Copy')">
    <UButton
      :aria-label="label ?? 'Copy value'"
      color="neutral"
      variant="ghost"
      size="xs"
      square
      :icon="copied ? PhCheck : PhCopySimple"
      class="dashboard-icon-button dashboard-copy-button"
      :class="{ 'dashboard-copy-button--compact': compact }"
      @click.stop="copyValue"
    />
  </UTooltip>
</template>
